const $360Delivery = {
    els: {
        globalLoading: null,
        walkUpVarId: null,
        region: null,
        district: null,
        datePicker: null,
        qty: null,
        datePicker: null,
        metafield: null,
        timeslotWrapper: null,
        timeSlotOptions: null,
        regionErrorEl: null,
        districtErrorEl: null,
        datePickerErrorEl: null,
        timeslotErrorEl: null
    },
    initEls() {
        this.els.globalLoading = document.getElementById('global-loading');
        this.els.walkUpVarId = document.getElementById('cart-delivery-walk-up-variant-id');
        this.els.region = document.querySelector('.cart-delivery-region');
        this.els.district = document.querySelector('.cart-delivery-district');
        this.els.datePicker = document.getElementById('cart-delivery-date-picker');
        this.els.qty = document.getElementById('cart-delivery-storey-qty');
        this.els.datePicker = document.getElementById('cart-delivery-date-picker');
        this.els.metafield = document.getElementById('cart-delivery-mf');
        this.els.timeslotWrapper = document.getElementById('timeslot-wrapper');
        this.els.timeSlotOptions = document.querySelector('.delivery-picker .timeslot-options');
        this.els.regionErrorEl = document.querySelector('.region-error');
        this.els.districtErrorEl = document.querySelector('.district-error');
        this.els.datePickerErrorEl = document.querySelector('.date-error');
        this.els.timeslotErrorEl = document.querySelector('.timeslot-error');
        this.els.lSide = document.querySelector('.left-side');
        this.els.rSide = document.querySelector('.right-side');
    },
    data: {
        dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        metafield: null,
        dateTimeMf: null,
        allowedDates: [],
        selectedDayNumber: null
    },
    initData() {
        this.data.metafield = JSON.parse(this.els.metafield.innerText.trim());
    },
    regionList: [
        {
            region_code: 'HK',
            region_name: 'Hong Kong'
        },
        {
            region_code: 'KL',
            region_name: 'Kowloon'
        },
        {
            region_code: 'NT',
            region_name: 'New Territories'
        }
    ],
    districtList: [
        {
            region_code: 'HK',
            districts: ["Aberdeen","Admiralty","Ap Lei Chau","Causeway Bay","Central","Chai Wan","Chung Hom Kok","Deep Water Bay","Fortress Hill","Happy Valley","Heng Fa Chuen","Kennedy Town","Mid-Levels","North Point","Pok Fu Lam","Quarry Bay","Repulse Bay","Sai Wan Ho","Sai Wan","Sai Ying Pun","Sau Kei Wan","Shek O","Sheung Wan","Siu Sai Wan","South Horizons","Stanley","Tai Hang","Tai Koo Shing","Tai Koo","Tai Tam","The Peak","Tin Hau","Wan Chai","Wong Chuk Hang"]
        },
        {
            region_code: 'KL',
            districts: ["Austin","Cheung Sha Wan","Choi Hung","Diamond Hill","Ho Man Tin","Hung Hom","Jordon","Kai Tak","Kowloon Bay","Kowloon City","Kowloon Tong","Kwun Tong","Lai Chi Kok","Lok Fu","Mei Foo","Mong Kok","Nam Cheong","Nam Tin","Ngau Tau Kok","Olympic","Prince Edward","Sham Shui Po","Shek Kip Mei","Sung Wong Toi","Tai Kok Tsui","To Kwa Wan","Tsim Sha Tsui","Whampoa","Wong Tai Sin","Yau Ma Tei","Yau Tong"]
        },
        {
            region_code: 'NT',
            districts: ["Chek Lap Kok","Discovery Bay","Fanling","Fo Tan","Hang Hu","HK Int'l Airport","Kwai Chung","Kwai Fong","Kwai Hing","Lai King","Lo Wu","Lohas Park","Lok Ma Chau","Ma On Shan","Po Lam","Sai Kung","Sha Tau Kok","Sham Tseng","Shatin","Shek Mun","Sheung Shui","Siu Lik Yuen","Ta Kwu Ling","Tai Po Market","Tai Po","Tai Wai","Tai Wo Hau","Tai Wo","Tin Shui Wai","Ting Kau","Tiu Keng Leng","Tseung Kwan O","Tsing Yi","Tsuen Wan","Tuen Mun","Tung Chung","University","Wo Che","Wu Kai Sha","Yuen Long"]
        }
    ],
    datepickerInstance: null,
    async setCartAttributes(callback = null) {
        const selectedTimeslot = document.querySelector('.timeslot-option-item input[type="radio"]:checked');
        const timeslot = selectedTimeslot ? selectedTimeslot.value : '';

        const selectedStairsAssistance = document.querySelector('.stairs-option-item input[type="radio"]:checked');
        const stairs = selectedStairsAssistance ? selectedStairsAssistance.value : '';

        const payload = {
            attributes: {
                '_areaDelivery': this.els.region.value,
                '_districtDelivery': this.els.district.value,
                'Date delivery': this.els.datePicker.value,
                'Timeslot delivery': timeslot,
                'Has Walk Up Fee': stairs,
                'Walk Up Stairs Qty': this.els.qty.value,
                '_dayDelivery': this.data.selectedDayNumber
            },
            // attributes: {
            //     '_areaDelivery': '',
            //     '_districtDelivery': '',
            //     'Date delivery': '',
            //     'Timeslot delivery': '',
            //     'Has Walk Up Fee': '',
            //     'Walk Up Stairs Qty': '',
            //     '_dayDelivery': ''
            // },
            note: `Date delivery: ${this.els.datePicker.value}\r\nTimeslot delivery: ${timeslot}`
        };

        this.toggleEnableCheckoutBtn();

        try {
            const response = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.description || 'Failed to update cart attribute');
            }

            const cart = await response.json();
            if(callback) callback();
        } catch (error) {
            console.error('Error updating cart attributes:', error);
        }
    },
    handleChangeRegion(e) {
        const regionCode = e.target.value;
                
        // Reset Datepicker and related fields
        if (this.datepickerInstance) {
            this.datepickerInstance.setDate(null); // Clears the selected date
        }
        if (this.els.datePicker) {
            this.els.datePicker.value = ''; // Clear the input field display
        }
        if (this.els.timeslotWrapper) {
            this.els.timeslotWrapper.classList.add('hide-mobile'); // Hide timeslots
        }
        if (this.els.timeSlotOptions) {
            this.els.timeSlotOptions.innerHTML = ''; // Clear timeslot options
        }
        this.data.selectedDayNumber = null; // Reset selected day number
        this.els.district.value = '';

        this.setCartAttributes();

        if(regionCode == '') return;
        this.els.region.closest('.global-select-div').querySelector('.inner').classList.remove('opacity-3');
        this.els.regionErrorEl.classList.add('hide-mobile');
        this.setDistrictOptions(regionCode);
    },
    setDistrictOptions(regionCode) {
        this.els.district.removeAttribute('disabled');
        const districts = this.districtList.find(district => district.region_code == regionCode);
        if(districts) {
            let districtsHtml = '<option value="">-- Please select --</option>';
            districts.districts.forEach(district => {
                districtsHtml += `<option value="${district}">${district}</option>`;
            });

            const cdDistrictTextEl = document.querySelector('.cd-district-text');
            const districtDefaultText = cdDistrictTextEl.getAttribute('data-default');
            cdDistrictTextEl.innerHTML = districtDefaultText;
            document.querySelector('.cart-delivery-district').innerHTML = districtsHtml;
        }

        const regionCodeLower = regionCode == 'KL' ? 'kw' : regionCode.toLowerCase();
        const key = `${regionCodeLower}_area`;
        this.data.dateTimeMf = this.data.metafield[key];
        if(this.data.dateTimeMf) {
            this.data.allowedDates = this.getAllowedDates();
        }
        this.initDatePicker();
    },
    handleChangeDistrict(e) {
        if(e.target.value == '') return;
        this.els.district.closest('.global-select-div').querySelector('.inner').classList.remove('opacity-3');
        this.els.districtErrorEl.classList.add('hide-mobile');
        this.setCartAttributes();
    },
    getStoreTime(date = null) {
        // In this case is Hongkong time
        let now = new Date();
        if(date){
            now = new Date(date);
        }
        const utcMilliseconds = now.getTime() + now.getTimezoneOffset() * 60 * 1000;
        const storeOffset = 8 * 60 * 60 * 1000;
        const storeMilliseconds = utcMilliseconds + storeOffset;
        const storeTime = new Date(storeMilliseconds);

        return storeTime;
    },
    getAllowedDates() {
        const storeTime = this.getStoreTime();
        const storeDay = this.data.dayNames[storeTime.getDay()];
        const todayData = this.data.dateTimeMf[storeDay.toLowerCase()]

        let daysInAdvance = parseInt(todayData.days_in_advance);
        let blocked_days = this.data.dateTimeMf.days_of_week;
        const all_blocked_dates = this.data.metafield?.bod_all || [];
        const region_blocked_dates = this.data.dateTimeMf?.blocked_out_dates || [];
        let blocked_dates = Array.from(new Set([ ...all_blocked_dates, ...region_blocked_dates ]));
        let max_date = 180;

        const blockedOutDays = {};
        this.data.dayNames.forEach((day, index) => {
            blockedOutDays[day] = blocked_days[index];
        });
        let blockedOutDates = blocked_dates;

        const allowedDates = [];
        for (let num = 1; num <= max_date; num++) {
            if(num >= daysInAdvance) {
                const date = new Date(storeTime);
                date.setDate(storeTime.getDate() + num);
                const dateString = this.formatDate(date);

                if(blockedOutDates.includes(dateString)) {
                    continue;
                }

                const dayName = date.toLocaleDateString('en-US', { weekday: 'long' });
                if(blockedOutDays[dayName]) {
                    allowedDates.push(date);
                }
            }
        }

        return allowedDates;
    },
    formatDate(date) {
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    },
    handleStairsAssistanceChange(value, walkUpChargeItemNum) {
        if(value == 'yes') {
            if(walkUpChargeItemNum != '') return;
            this.els.qty.value = 1;
            this.setCartAttributes(() => {
                this.addWalkUpChargeProduct();
            });
        } else {
            if(walkUpChargeItemNum != '') {
                this.els.globalLoading.classList.add('active');
                this.els.qty.value = 0;
                this.setCartAttributes(() => {
                    updateCartQty(walkUpChargeItemNum, 0, () => {
                        window.location.reload();
                    });
                });
            }
        }
    },
    addWalkUpChargeProduct() {
        this.els.globalLoading.classList.add('active');
        const walkUpChargeVariantId = this.els.walkUpVarId.innerText.trim();
        const qty = this.els.qty.value;

        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                quantity: qty, 
                id: walkUpChargeVariantId
            },
            dataType: 'json',
            error:function(error){
                console.log(error);
            },
            success:function(line_item){
                window.location.reload();
            }
        });
    },
    debouncedHandleChangeStoreyQty(el, walkUpChargeItemNum) {
        if (this.timer) clearTimeout(this.timer);

        this.timer = setTimeout(() => {
            el.setAttribute('disabled', true);
            this.setCartAttributes(() => {
                this.handleChangeStoreyQty(walkUpChargeItemNum);
            });
        }, 1000);
    },
    handleChangeStoreyQty(walkUpChargeItemNum) {
        this.els.globalLoading.classList.add('active');
        if(walkUpChargeItemNum == '') {
            this.addWalkUpChargeProduct();
        } else {
            updateCartQty(walkUpChargeItemNum, this.els.qty.value, () => {
                window.location.reload();
            });
        }
    },
    initDatePicker() {
        const weekdays = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
        const datepickerOptions = {
            inline: true,
            weekStart: 1,
            i18n: { weekdays: weekdays },
            within: this.data.allowedDates,
            min: new Date(Date.UTC(2999, 11, 31)), // Far future
            max: new Date(Date.UTC(1900, 0, 1)),  // Far past
            deserialize: (dateString) => {
                if (typeof dateString !== 'string') {
                    const d = new Date(dateString);
                    return !isNaN(d.getTime()) ? d : null;
                }
                const parts = dateString.split('-');
                if (parts.length === 3) {
                    const day = parseInt(parts[0], 10);
                    const month = parseInt(parts[1], 10) - 1; // JavaScript months are 0-indexed
                    const year = parseInt(parts[2], 10);
                    if (!isNaN(day) && !isNaN(month) && !isNaN(year) && new Date(year, month, day).getDate() === day) {
                        return new Date(year, month, day);
                    }
                }
                const parsedDate = new Date(dateString); // Fallback attempt
                return !isNaN(parsedDate.getTime()) ? parsedDate : null;
            },
            serialize: this.formatDate, // to format date dd-mm-yyyy
            onChange: (selectedDate) => {
                if (selectedDate) {
                    this.els.datePickerErrorEl.classList.add('hide-mobile');
                    const dayIndex = selectedDate.getDay(); // 0 for Sunday, 1 for Monday, ...
                    this.data.selectedDayNumber = dayIndex;
                    const dayName = this.data.dayNames[dayIndex];
                    let timeSlotsHtml = '';
                    if (this.data.dateTimeMf) {
                        const dayData = this.data.dateTimeMf[dayName.toLowerCase()];
                        if (dayData && dayData.timeslots) {
                            const selectedTimeslot = this.els.timeslotWrapper.getAttribute('data-timeslot');
                            // Sort timeslots by start time
                            dayData.timeslots.sort((a, b) => {
                                const startTimeA = parseInt(a.split('-')[0], 10);
                                const startTimeB = parseInt(b.split('-')[0], 10);
                                return startTimeA - startTimeB;
                            });

                            dayData.timeslots.forEach((timeslot, index) => {
                                const formattedTimeslot = this.formatTimeslot(timeslot);
                                const checked = selectedTimeslot === timeslot ? 'checked' : '';

                                timeSlotsHtml += `
                                    <div class="timeslot-option-item">
                                        <input 
                                            type="radio" 
                                            name="attributes[Timeslot delivery]" 
                                            id="timeslot_${index}" 
                                            value="${timeslot}" 
                                            class="button-radio-input" 
                                            onchange="$360Delivery.handleChangeTimeSlot();"
                                            ${checked}
                                        >
                                        <label for="timeslot_${index}" class="button-radio-label">${formattedTimeslot}</label>
                                    </div>
                                `;
                            });
                        }
                    }
                    
                    this.els.timeSlotOptions.innerHTML = timeSlotsHtml;
                    // Check if timeslots were actually populated before showing the wrapper
                    const hasTimeSlots = this.els.timeSlotOptions.children.length > 0;
                    if(hasTimeSlots) {
                        this.els.timeslotWrapper.classList.remove('hide-mobile');
                    } else {
                        this.els.timeslotWrapper.classList.add('hide-mobile')
                    }

                    this.setCartAttributes();
                }
            }
        };

        if (this.data.allowedDates && this.data.allowedDates.length > 0) {
            datepickerOptions.within = this.data.allowedDates;
            // Reset min and max to allow 'within' to be the sole arbiter of enabled dates
            datepickerOptions.min = false; 
            datepickerOptions.max = false;
        }
        // If allowedDates is empty or not present, the default min/max above will disable all dates.
        // The `within: false` (or an empty array passed to `within` which the library converts to false)
        // means the 'within' check itself won't restrict dates, letting min/max control.

        if (this.datepickerInstance) {
            // If instance exists, update its options
            // The Datepicker's set method can take an object of options
            this.datepickerInstance.set(datepickerOptions);
        } else {
            // Create new instance, passing the DOM element
            this.datepickerInstance = new Datepicker(this.els.datePicker, datepickerOptions);
        }
    },
    handleChangeTimeSlot() {
        this.els.timeslotErrorEl.classList.add('hide-mobile');
        this.setCartAttributes();
    },
    formatTimeslot(timeslotString) {
        if (typeof timeslotString !== 'string' || timeslotString.length !== 9 || timeslotString.charAt(4) !== '-') {
            // Return original or handle error if format is unexpected
            return timeslotString;
        }
        const parts = timeslotString.split('-');
        const startTime = parts[0];
        const endTime = parts[1];

        const formatPart = (timePart) => {
            if (timePart.length !== 4) return timePart; // Should be HHMM
            return `${timePart.substring(0, 2)}:${timePart.substring(2, 4)}`;
        };

        return `${formatPart(startTime)} - ${formatPart(endTime)}`;
    },
    async initCartAttributes() {
         try {
            const response = await fetch('/cart.js');

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.description || 'Failed to update cart attribute');
            }

            const {attributes} = await response.json();

            if(attributes?._areaDelivery) {
                const region = this.regionList.find(region => region.region_code == attributes._areaDelivery);
                if(region) {
                    this.els.region.closest('.global-select-div').querySelector('.inner').innerText = region.region_name;
                    this.els.region.closest('.global-select-div').querySelector('.inner').classList.remove('opacity-3');
                    this.setDistrictOptions(region.region_code);
                }
            }

            if(attributes?._districtDelivery) {
                const selectedDistrict = attributes?._districtDelivery;
                this.els.district.value = selectedDistrict;
                this.els.district.closest('.global-select-div').querySelector('.inner').innerText = selectedDistrict;
                this.els.district.closest('.global-select-div').querySelector('.inner').classList.remove('opacity-3');
            }

            if(attributes['Date delivery']) {
                const dateString = attributes['Date delivery'];
                if (this.datepickerInstance) {
                    this.datepickerInstance.setDate(dateString);
                    this.datepickerInstance.render(); // Force re-render to apply selection class
                     // The setDate method should trigger onChange, which populates timeslots.
                     // Now, check and set the timeslot if it exists in attributes.
                    if (attributes['Timeslot delivery']) {
                        const timeslotValue = attributes['Timeslot delivery'];
                        // Use a slight delay or ensure DOM is updated if timeslots are populated async
                        setTimeout(() => {
                            const timeslotInput = document.querySelector(`input[name="attributes[Timeslot delivery]"][value="${timeslotValue}"]`);
                            if (timeslotInput) timeslotInput.checked = true;
                        }, 500);
                    }
                }
            }
        } catch (error) {
            console.error('Error getting cart info:', error);
        }
    },
    isAllowToCheckout() {
        let isAllow = true;
        if(!isPreorder) {
            if(this.els.region.value == '') {
                isAllow = false;
                this.els.regionErrorEl.classList.remove('hide-mobile');
            }
            if(this.els.district.value == '') {
                isAllow = false;
                this.els.districtErrorEl.classList.remove('hide-mobile');
            }
            if(this.els.datePicker.value == '') {
                isAllow = false;
                this.els.datePickerErrorEl.classList.remove('hide-mobile');
            }
            const selectedTimeslot = document.querySelector('.timeslot-option-item input[type="radio"]:checked');
            if(!selectedTimeslot) {
                isAllow = false;
                this.els.timeslotErrorEl.classList.remove('hide-mobile');
            }
        }
        return isAllow;
    },
    toggleEnableCheckoutBtn(){
        if(this.isAllowToCheckout() && $('input.cart_tnc_input').is(':checked')) {
            $('#checkout-button').removeAttr('disabled');
        } else {
            $('#checkout-button').attr('disabled', true);
        }
    },
    updateDeliveryLocation() {
        if(isPreorder) {
            this.els.lSide.classList.add('hide-mobile');
            this.els.rSide.style.width = '100%';
        } else {
            this.els.lSide.classList.remove('hide-mobile');
            this.els.rSide.style.width = '';
        }
    }
};

document.addEventListener('DOMContentLoaded', function() {
    $360Delivery.initEls();
    $360Delivery.initData();
    $360Delivery.initDatePicker();
    $360Delivery.initCartAttributes();
    $360Delivery.updateDeliveryLocation();
});